import { Tabs as AntdTabs } from "antd"
import tw, { styled } from "twin.macro"

export default function Tabs({ ...props }) {
    return <StyledTabs type="card" {...props} />
}

const StyledTabs = styled(AntdTabs)`
    .ant-tabs-tab {
        ${tw`rounded-t-lg!`}
    }
`
